@if (moduleId) {
  <my-modules-linked-fields [moduleId]="moduleId" [version]="version">
  </my-modules-linked-fields>
}